import moment from 'moment'
import { IOrder, IOrderItem } from '../../types'

const parseOrder = (order: IOrder) => ({
  order_id: order.id,
  order_uuid: order.uuid,
  hub: order.hub,
  delivery_status: order.order_deliveries[0].delivery_status,
  delivery_method: order.order_deliveries[0].shipping_method,
  delivery_estimated: {
    from: moment(
      order.order_deliveries[0].delivery_estimated +
        ' ' +
        order.order_deliveries[0].shipping_details?.open,
    ).toISOString(),
    to: moment(
      order.order_deliveries[0].delivery_estimated +
        ' ' +
        order.order_deliveries[0].shipping_details?.close,
    ).toISOString(),
  },
  total: {
    subtotal: order.subtotal,
    delivery_cost: order.delivery_cost,
    discount: order.discount,
    total: order.total,
    transfer_total: order.transfer_total,
  },
  notification: order.notification || {
    pushReceived: false,
    soundPlayed: false,
  },
  itens: order.items?.map((item: IOrderItem & { refuse_motive?: string }) => ({
    refuse_motive: item.refuse_motive,
    ean: item.product_package.ean,
    name: item.product_package.product.name,
    sell_price_per_unit: item.package_price,
    tranfer_price_per_unit: item.transfer_amount / item.quantity,
    quantity: item.quantity,
  })),
})

export const data = {
  receivedOrder: (order: IOrder) => ({
    event: 'order_received',
    order: parseOrder(order),
  }),
  lostOrder: (order: IOrder) => ({
    event: 'order_lost',
    order: parseOrder(order),
  }),
  canceledOrder: (order: IOrder) => ({
    event: 'order_canceled',
    order: parseOrder(order),
  }),

  acceptIntention: (order: IOrder) => ({
    event: 'order_accept_intention',
    order: parseOrder(order),
  }),
  accepted: (order: IOrder) => ({
    event: 'order_accept_confirmation',
    order: parseOrder(order),
  }),

  refuseIntention: (order: IOrder) => ({
    event: 'order_refuse_intention',
    order: parseOrder(order),
  }),
  refuseItemMotiveChange: (order: IOrder) => ({
    event: 'order_refuse_item_motive_change',
    order: parseOrder(order),
  }),
  refused: (order: IOrder) => ({
    event: 'order_refuse_confirmation',
    order: parseOrder(order),
  }),
  print: (order: IOrder) => ({
    event: 'order_print',
    order: parseOrder(order),
  }),
  invoiceInfo: (order: IOrder) => ({
    event: 'order_invoice_info',
    order: parseOrder(order),
  }),
  sendInvoiceSucess: (order: IOrder) => ({
    event: 'order_invoice_success',
    order: parseOrder(order),
  }),
  printLabel: (order: IOrder) => ({
    event: 'order_print_label',
    order: parseOrder(order),
  }),
}
